import React from 'react'
import PropTypes from 'prop-types'
import { Grid, GridItem } from '../grid'
import css from './style.css'
import JewelryDetails from '../jewelry-details'
import ItemHeader from '../item-header'
import JewelryPhoto from '../jewelry-photo'
import Price from '../price'

const SummaryJewelry = props => (
  <Grid>
    <GridItem col='2/10'>
      <JewelryPhoto small summary />
    </GridItem>
    <GridItem col='7/10'>
      <ItemHeader type='jewelry' data={props.jewelry.data} index={props.index} />
      <JewelryDetails data={props.jewelry.data} additionalNotes={props.jewelry.additionalNotes} />
    </GridItem>
    <GridItem col='1/10'>
      <Price price={props.price} styleClass={css.price} />
    </GridItem>
  </Grid>
)

SummaryJewelry.propTypes = {
  jewelry: PropTypes.object.isRequired,
  index: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired
}

export default SummaryJewelry



// WEBPACK FOOTER //
// ./src/components/summary-jewelry/index.js